import React, { useState, useEffect, useContext } from "react";
import { BrowserRouter as Router, Link, useParams } from "react-router-dom";
import RejectAlert from "../../components/Alert/RejectAlert";
import Countdown from "react-countdown";

import { api } from "../../utils/Api";
import toast from "react-hot-toast";

export default function CompanyWorkInvitition(props: any) {
  const [invitition, setInvitition] = useState([]);
  const [open, setOpen] = useState();
  // const [history, setHistory] = useState([]);
  const [id_values, SetIdValues] = useState(useParams());
  const [history, SetHistory] = useState(Boolean);
  const [next_page, SetNextPage] = useState(false);
  const [page_no, SetPageNo] = useState(1);
  const [historyVal, SetHistoryVal] = useState([]);

  const [reject_modal, SetRejectModal] = useState({
    is_open: false,
    title: "",
    record: {},
    index: "",
  });

  useEffect(() => {
    console.log("Activity On mount :", props);
    console.log("Activity On mount id_values :", id_values);
  }, []);

  useEffect(() => {
    console.log("on history change :", history);

    get_job_invitations();
    if (history) {
      get_history();
    }
  }, [history]);

  async function get_job_invitations() {
    let invitition_val = invitition;
    let pass_data: any = {
      get: {
        page: page_no,
      },
    };
    if (id_values.company_id != "all") {
      pass_data.get.company_id = id_values.company_id;
    }
    if (id_values.work_id != "all") {
      pass_data.get.id = id_values.work_id;
    }
    if (history) {
      pass_data.get.history = false;
    }

    console.log("pass_data :", pass_data);

    let response = await api("/company/job_invitations", pass_data);

    console.log("job_invitations response :", response.response.data);
    setInvitition(response.response.data);
    // SetHistoryData(response.response.data);

    setOpen(response.response.opened_data);

    // for (let i = 0; i < response.response.data.length; i++) {
    //   invitition_val.push(response.response.data[i]);
    // }

    // setInvitition(invitition_val);
    if (response.response.data) {
      for (let i = 0; i < response.response.data.length; i++) {
        invitition_val.push(response.response.data[i]);
      }
    } else {
      invitition_val = [];
    }

    setInvitition(invitition_val);

    if (response.response.next_page) {
      SetPageNo(page_no + 1);
      SetNextPage(true);
    } else {
      SetNextPage(false);
    }
  }

  async function get_history() {
    let history_val = historyVal;
    console.log(historyVal);
    let pass_data: any = {
      get: {
        page: page_no,
      },
    };
    if (id_values.company_id != "all") {
      pass_data.get.company_id = id_values.company_id;
    }
    if (id_values.work_id != "all") {
      pass_data.get.id = id_values.work_id;
    }
    if (history) {
      pass_data.get.history = true;
    }

    console.log("pass_data :", pass_data);

    let response = await api("/company/job_invitations", pass_data);

    console.log("job_invitations response :", response.response.data);
    // setInvitition(response.response.data);
    SetHistoryVal(response.response.data);

    setOpen(response.response.opened_data);
    if (response.response.data) {
      for (let i = 0; i < response.response.data.length; i++) {
        history_val.push(response.response.data[i]);
      }
    } else {
      history_val = [];
    }

    SetHistoryVal(history_val);

    if (response.response.next_page) {
      SetPageNo(page_no + 1);
      SetNextPage(true);
    } else {
      SetNextPage(false);
    }
  }

  async function accept_invite(item: any, index: any) {
    let pass_data = {
      post: {
        invitation_id: item.id,
      },
    };
    let data = await api("/company/accept_job_invitation", pass_data);
    console.log("delete_service response :", data);
    if (data.status_code == 200) {
      // let old_services = service_data;
      // old_services.splice(index, 1);
      // SetServiceData([...old_services]);
      if (data.response.hasOwnProperty("message")) {
        toast.error(data.response.message);
      }
      let pass_data: any = {
        get: {
          page: 1,
        },
      };

      let response = await api("/company/job_invitations", pass_data);

      console.log("job_invitations response :", response.response.data);
      if (response.status_code == 200) {
        if (response.response.hasOwnProperty("data")) {
          setInvitition(response.response.data);
        }
      }
    }
  }

  async function reject_invite(record: any, index: any) {
    let pass_data = {
      post: {
        invitation_id: record,
      },
    };
    let data = await api("/company/reject_job_invitation", pass_data);
    console.log("delete_service response :", data);
    if (data.status_code == 200) {
      // let old_services = service_data;
      // old_services.splice(index, 1);
      // SetServiceData([...old_services]);
      let pass_data: any = {
        get: {
          page: 1,
        },
      };
      let response = await api("/company/job_invitations", pass_data);

      console.log("job_invitations response :", response.response.data);
      setInvitition(response.response.data);
    }
  }

  return (
    <>
      <div className="bg-white mb-3 pt-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h5 className="mb-3">Job Invititions</h5>
              <div className="col-lg-12">
                <nav className="pt-1 sticky-tabs">
                  <div className="nav nav-tabs " id="nav-tab" role="tablist">
                    <button
                      className="nav-link active"
                      id="active-users-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#active-users"
                      type="button"
                      role="tab"
                      aria-controls="active-users"
                      aria-selected="true"
                      onClick={() => {
                        SetHistory(false);
                        SetPageNo(1);
                        setInvitition([]);
                      }}
                    >
                      Invitition
                    </button>
                    <button
                      className="nav-link"
                      id="deleted-users-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#history-tasks"
                      type="button"
                      role="tab"
                      aria-controls="deleted-users"
                      aria-selected="false"
                      onClick={() => {
                        SetHistory(true);
                        SetPageNo(1);
                        SetHistoryVal([]);
                      }}
                    >
                      History
                    </button>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      {invitition || open ? (
        <>
          <div className="col-lg-12 basic-list">
            <div className="tab-content" id="nav-tabContent">
              <div
                className="tab-pane fade show active"
                id="active-users"
                role="tabpanel"
                aria-labelledby="active-users-tab"
              >
                <div className="container">
                  <div className="row">
                    <ul className="list-group list-group-flush">
                      <div>
                        {open && (
                          <div className=" mb-2 br-3 p-3 col-lg-8 mx-auto open-task">
                            <div>
                              {/* ((((((((((())))))))))) */}
                              <div>
                                <div className="d-flex ">
                                  <div>
                                    <div className="fs-14">{open.task}</div>
                                    <div className="text-muted v">
                                      Sevrice : {open.service_name}
                                    </div>
                                  </div>

                                  <div className="ms-auto text-center">
                                    <div className="d-flex">
                                      <div className="fs-14">
                                        {item.quantity}
                                      </div>
                                      <div className="ms-1">Qty</div>
                                    </div>
                                    {open.max_working_hours && (
                                      <div>
                                        max time :{open.max_working_hours} hrs
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="d-lg-flex">
                                  <div>
                                    <div className="mb-1">
                                      {open.company_name}
                                    </div>
                                  </div>
                                  <div className="ms-auto">
                                    <div className="text-muted">
                                      {/* {moment(open.created_at).fromNow()} */}
                                      {open.created_at}
                                    </div>
                                  </div>
                                </div>

                                <div className="d-lg-flex mb-2">
                                  <div>Customer : {open.customer_name}</div>
                                  <div className="ms-auto">
                                    {open.hasOwnProperty("event_name") && (
                                      <div>{open.event_name}</div>
                                    )}
                                  </div>
                                </div>

                                <div>File Name : {open.client_name}</div>
                              </div>
                              {/* ((((((((((Button)))))))))) */}

                              {open.status == null && (
                                <div className="text-center">
                                  <button
                                    type="button"
                                    className="btn btn-primary px-3 btn-sm m-2"
                                    onClick={() => {
                                      accept_invite(open, index);
                                    }}
                                  >
                                    Accept
                                  </button>
                                  <button
                                    type="button"
                                    className="btn px-3 btn-sm btn-danger m-2"
                                    data-bs-toggle="modal"
                                    data-bs-target="#exampleModal"
                                    onClick={() => {
                                      // delete_service(data, s_index);
                                      SetRejectModal((prevValue) => {
                                        prevValue.is_open = true;
                                        prevValue.title = "invitation";
                                        prevValue.record = open.id;
                                        prevValue.index = index;
                                        return { ...prevValue };
                                      });
                                    }}
                                  >
                                    Reject
                                  </button>
                                </div>
                              )}
                            </div>
                            {/* ((((((((((((((((((((((((((((End..!)))))))))))))))))))))))))))) */}
                            <div>
                              <div className="d-flex">
                                <div className="mx-auto">
                                  <div className="col card-text">
                                    {open.status == "Accepted" && (
                                      <span className="badge bg-primary">
                                        Accepted
                                      </span>
                                    )}
                                    {open.status == "Rejected" && (
                                      <span className="badge bg-danger">
                                        Rejected
                                      </span>
                                    )}
                                    {open.status == "Deleted" && (
                                      <span className="badge bg-danger">
                                        Deleted
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        {invitition?.map((item: any, index: any) =>
                          item.app_id == 2 ? (
                            <div className="box-2 mb-2 br-3 p-3 col-lg-8 mx-auto">
                              <div>
                                {/* ((((((((((())))))))))) */}
                                <div>
                                  <div className="d-lg-flex">
                                    <div>
                                      <div className="f-14">
                                        {item.service_name}
                                      </div>

                                      <div>
                                        <h6>{item.event_name}</h6>
                                      </div>

                                      {item.event_starts && (
                                        <p className="text-muted">
                                          <i className="fa-regular fa-clock"></i>{" "}
                                          {item.event_starts} to{" "}
                                          {item.event_ends}
                                        </p>
                                      )}
                                      {/* <h5>({item.quantity})</h5> */}

                                      {item.client_name && (
                                        <h6>
                                          Client Name : {item.client_name}
                                        </h6>
                                      )}
                                    </div>
                                    <div className="ms-auto">
                                      <div className="">
                                        {/* {moment(item.created_at).fromNow()} */}

                                        {item.created_at}
                                      </div>
                                      <div className="">
                                        {/* {moment(item.created_at).fromNow()} */}
                                        {item.company_name}
                                      </div>
                                    </div>
                                  </div>

                                  <div>
                                    <div className="mb-1">
                                      {item.event_venue && (
                                        <div>Venue: {item.event_venue}</div>
                                      )}
                                      {item.event_location && (
                                        <div>
                                          <i className="fa-solid fa-location-dot"></i>{" "}
                                          {item.event_location}
                                        </div>
                                      )}
                                    </div>
                                  </div>

                                  <div className="d-lg-flex">
                                    <div>Exposure pay : {item.amount}</div>
                                    <div className="ms-auto">
                                      <div className="">
                                        {/* {moment(item.created_at).fromNow()} */}
                                        {item.client_name && (
                                          <h6>
                                            Client Name : {item.client_name}
                                          </h6>
                                        )}
                                      </div>
                                    </div>
                                  </div>

                                  {item.client_name && (
                                    <div>Customer : {item.customer_name}</div>
                                  )}

                                  {item.client_name && (
                                    <div>File Name : {item.client_name}</div>
                                  )}
                                </div>
                                {/* ((((((((((Button)))))))))) */}
                                {item.status == null && (
                                  <div className="text-center">
                                    <button
                                      type="button"
                                      className="btn btn-primary px-3 btn-sm m-2"
                                      onClick={() => {
                                        accept_invite(item, index);
                                      }}
                                    >
                                      Accept
                                    </button>
                                    <button
                                      type="button"
                                      className="btn px-3 btn-sm btn-danger m-2"
                                      data-bs-toggle="modal"
                                      data-bs-target="#exampleModal"
                                      onClick={() => {
                                        // delete_service(data, s_index);
                                        SetRejectModal((prevValue) => {
                                          prevValue.is_open = true;
                                          prevValue.title = "invitation";
                                          prevValue.record = item.id;
                                          prevValue.index = index;
                                          return { ...prevValue };
                                        });
                                      }}
                                    >
                                      Reject
                                    </button>
                                  </div>
                                )}
                              </div>
                              {/* ((((((((((((((((((((((((((((End..!)))))))))))))))))))))))))))) */}
                              <div>
                                <div className="d-flex">
                                  <div className="mx-auto">
                                    <div className="col card-text">
                                      {item.status == "Accepted" && (
                                        <span className="badge bg-primary">
                                          Accepted
                                        </span>
                                      )}
                                      {item.status == "Rejected" && (
                                        <span className="badge bg-danger">
                                          Rejected
                                        </span>
                                      )}
                                      {item.status == "Deleted" && (
                                        <span className="badge bg-danger">
                                          Deleted
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="box-2 mb-2 br-3 p-3 col-lg-8 mx-auto">
                              <div>
                                {/* ((((((((((())))))))))) */}
                                <div>
                                  <div className="d-flex ">
                                    <div>
                                      <div className="fs-14">{item.task}</div>
                                      <div className="text-muted fs-14">
                                        Sevrice : {item.service_name}
                                      </div>
                                    </div>
                                    <div className="ms-auto text-center">
                                      <div className="d-flex">
                                        <div className="fs-14">
                                          {item.quantity}
                                        </div>
                                        <div className="ms-1">Qty</div>
                                      </div>
                                      {item.max_working_hours && (
                                        <div>
                                          max time :{item.max_working_hours} hrs
                                        </div>
                                      )}
                                    </div>
                                  </div>

                                  <div className="d-lg-flex">
                                    <div>
                                      <div className="mb-1">
                                        {item.company_name}
                                      </div>
                                    </div>
                                    <div className="ms-auto">
                                      <div className="text-muted">
                                        {/* {moment(item.created_at).fromNow()} */}
                                        {item.created_at}
                                      </div>
                                    </div>
                                  </div>

                                  <div className="d-lg-flex mb-2">
                                    <div>Customer : {item.customer_name}</div>
                                    <div className="ms-auto">
                                      {item.hasOwnProperty("event_name") && (
                                        <div>{item.event_name}</div>
                                      )}
                                    </div>
                                  </div>

                                  <div>File Name : {item.client_name}</div>
                                </div>
                                {/* ((((((((((Button)))))))))) */}
                                {item.status == null && (
                                  <div className="text-center">
                                    <button
                                      type="button"
                                      className="btn btn-primary px-3 btn-sm m-2"
                                      onClick={() => {
                                        accept_invite(item, index);
                                      }}
                                    >
                                      Accept
                                    </button>
                                    <button
                                      type="button"
                                      className="btn px-3 btn-sm btn-danger m-2"
                                      data-bs-toggle="modal"
                                      data-bs-target="#exampleModal"
                                      onClick={() => {
                                        // delete_service(data, s_index);
                                        SetRejectModal((prevValue) => {
                                          prevValue.is_open = true;
                                          prevValue.title = "invitation";
                                          prevValue.record = item.id;
                                          prevValue.index = index;
                                          return { ...prevValue };
                                        });
                                      }}
                                    >
                                      Reject
                                    </button>
                                  </div>
                                )}
                              </div>
                              {/* ((((((((((((((((((((((((((((End..!)))))))))))))))))))))))))))) */}
                              <div>
                                <div className="d-flex">
                                  <div className="mx-auto">
                                    <div className="col card-text">
                                      {item.status == "Accepted" && (
                                        <span className="badge bg-primary">
                                          Accepted
                                        </span>
                                      )}
                                      {item.status == "Rejected" && (
                                        <span className="badge bg-danger">
                                          Rejected
                                        </span>
                                      )}
                                      {item.status == "Deleted" && (
                                        <span className="badge bg-danger">
                                          Deleted
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                        )}
                      </div>
                    </ul>
                  </div>
                </div>

                {next_page ? (
                  <div className="text-center mt-3 mb-3">
                    <button
                      type="button"
                      className="load btn btn-primary px-3 "
                      onClick={() => {
                        get_job_invitations();
                      }}
                    >
                      <b>Load More</b>
                    </button>
                  </div>
                ) : (
                  ""
                )}
              </div>

              <div
                className="tab-pane fade"
                id="history-tasks"
                role="tabpanel"
                aria-labelledby="deleted-users-tab"
              >
                <div className="container">
                  {historyVal?.map((item: any, index: any) =>
                    item.app_id == 2 ? (
                      <div className="box-2 p-3 br-3 mb-2 col-lg-8 mx-auto">
                        <div className="d-flex">
                          <div>
                            <div className="f-14">{item.service_name}</div>

                            <div>
                              <h6>{item.event_name}</h6>
                            </div>

                            {item.event_starts && (
                              <p className="text-muted">
                                <i className="fa-regular fa-clock"></i>{" "}
                                {item.event_starts} to {item.event_ends}
                              </p>
                            )}
                            {/* <h5>({item.quantity})</h5> */}

                            {item.event_venue && (
                              <div>Venue: {item.event_venue}</div>
                            )}
                            {item.event_location && (
                              <div>
                                <i className="fa-solid fa-location-dot"></i>{" "}
                                {item.event_location}
                              </div>
                            )}

                            {item.client_name && (
                              <h6>Client Name : {item.client_name}</h6>
                            )}
                          </div>

                          {item.event_latitude && item.event_longitude ? (
                            <div className="ms-lg-auto">
                              <div className="text-center">
                                <a
                                  target="_blank"
                                  href={
                                    "https://www.google.com/maps/search/?api=1&query=" +
                                    item.event_latitude +
                                    "%2C" +
                                    item.event_longitude
                                  }
                                >
                                  <i className="fas fa-directions fs-38"></i>
                                  <div className="text-uppercase mt-1 fs-12">
                                    Get Directions
                                  </div>
                                </a>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>

                        <div>Exposure pay : {item.amount}</div>

                        <p className="mt-1 fs-14 text-muted">
                          {item.company_name}
                        </p>

                        {item.hasOwnProperty("rework_message") ? (
                          <div>
                            <h4>Rework</h4>
                            <p>Rework Message : {item.rework_message}</p>
                          </div>
                        ) : null}

                        {item.hasOwnProperty("rework_salary_amount") ? (
                          <div>
                            <p>
                              Rework Salary Amount : {item.rework_salary_amount}
                            </p>
                          </div>
                        ) : null}

                        <div className="d-flex">
                          <div className="text-muted">{item.created_at}</div>
                          <div className="ms-auto">
                            <div className="col card-text">
                              {item.status == "Accepted" && (
                                <span className="badge bg-primary">
                                  Accepted
                                </span>
                              )}

                              {item.status == "Rejected" && (
                                <span className="badge bg-danger">
                                  Rejected
                                </span>
                              )}

                              {item.status == "Deleted" && (
                                <span className="badge bg-danger">Deleted</span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="box-2 p-3 br-3 mb-2 col-lg-8 mx-auto">
                        <div className="d-flex">
                          <div>
                            <h5>{item.task}</h5>
                            <div className="text-muted">
                              Sevrice : {item.service_name}
                            </div>
                            <div>{item.event_name}</div>
                            <div>Customer : {item.customer_name}</div>
                            <div>File Name : {item.client_name}</div>
                          </div>
                          <div className="ms-auto text-center">
                            <div className="d-flex">
                              <div className="fs-14">{item.quantity}</div>
                              <div className="ms-1">Qty</div>
                            </div>
                            {item.max_working_hours && (
                              <div>max time :{item.max_working_hours} hrs</div>
                            )}
                          </div>
                        </div>
                        <p>{item.company_name}</p>
                        <div className="d-flex">
                          <div className="text-muted">{item.created_at}</div>
                          <div className="ms-auto">
                            <div className="col card-text">
                              {item.status == "Accepted" && (
                                <span className="badge bg-primary">
                                  Accepted
                                </span>
                              )}

                              {item.status == "Rejected" && (
                                <span className="badge bg-danger">
                                  Rejected
                                </span>
                              )}

                              {item.status == "Deleted" && (
                                <span className="badge bg-danger">Deleted</span>
                              )}
                            </div>
                          </div>
                        </div>
                        {item.status == null && (
                          <>
                            <button
                              type="button"
                              className="btn btn-primary m-2"
                              onClick={() => {
                                accept_invite(item, index);
                              }}
                            >
                              Accept
                            </button>
                            <button
                              type="button"
                              className="btn btn-danger m-2"
                              data-bs-toggle="modal"
                              data-bs-target="#exampleModal"
                              onClick={() => {
                                // delete_service(data, s_index);
                                SetRejectModal((prevValue) => {
                                  prevValue.is_open = true;
                                  prevValue.title = "invitation";
                                  prevValue.record = item.id;
                                  prevValue.index = index;
                                  return { ...prevValue };
                                });
                              }}
                            >
                              Reject
                            </button>
                          </>
                        )}
                        &nbsp;
                      </div>
                    )
                  )}
                </div>
                {next_page ? (
                  <div className="text-center mt-3 mb-3">
                    <button
                      type="button"
                      className="load btn btn-primary px-3 "
                      onClick={() => {
                        get_history();
                      }}
                    >
                      <b>Load More</b>
                    </button>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </>
      ) : (
        <h5>No job invitations</h5>
      )}

      <RejectAlert
        open={reject_modal.is_open}
        title={reject_modal.title}
        record={reject_modal.record}
        index={reject_modal.index}
        close={(data) => {
          SetRejectModal((prevValue) => {
            prevValue.is_open = false;
            return { ...prevValue };
          });

          if (data.action === "delete") {
            console.log("delete Service : ", data);
            reject_invite(data.value, data.index);
          }
        }}
      />
    </>
  );
}
